module.exports = __webpack_public_path__ + "static/media/boss_clothes_think.2715c299.png";